import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Previous.png'
import _imports_1 from '@/assets/Next.png'
import _imports_2 from '@/assets/Settings.png'


const _withScopeId = n => (_pushScopeId("data-v-b579f4e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-main" }
const _hoisted_2 = { class: "audio-controls" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "song-controls" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "song-bar" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "settings-popup"
}
const _hoisted_9 = { class: "popup-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-title" }, "Settings", -1))
const _hoisted_11 = { class: "popup-content-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Folder", -1))
const _hoisted_13 = { class: "popup-content-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Interval", -1))
const _hoisted_15 = { class: "popup-content-row no-label" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "randomcb" }, "Random Images", -1))
const _hoisted_17 = {
  class: "popup-content-row popup-buttons",
  style: {"flex-direction":"row"}
}
const _hoisted_18 = {
  class: "popup-content-row popup-buttons",
  style: {"flex-direction":"row"}
}
const _hoisted_19 = {
  key: 0,
  class: "popup-content-row popup-buttons",
  style: {"flex-direction":"row"}
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 1,
  class: "popup-error"
}
const _hoisted_22 = {
  key: 2,
  class: "popup-content-row no-label"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "allowRemote" }, "Allow Remote Control", -1))
const _hoisted_24 = { class: "settings-error" }
const _hoisted_25 = {
  key: 0,
  class: "settings-popup"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "settings-popup-background",
  style: { filter: 'none' }
}, null, -1))
const _hoisted_27 = {
  class: "popup-container",
  style: {"display":"flex","flex-direction":"column","align-items":"center"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-title" }, "Remote Control for main Slideshow", -1))
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  class: "remote-item",
  style: {"flex-direction":"column"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Change the volume of the main slideshow songs", -1))
const _hoisted_32 = {
  key: 0,
  class: "login-popup"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-title" }, "In order to view, please enter your folder name and the password to the folder.", -1))
const _hoisted_34 = { class: "popup-content-row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Folder", -1))
const _hoisted_36 = { class: "popup-content-row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Password", -1))
const _hoisted_38 = { class: "popup-buttons" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "popup-error" }
const _hoisted_42 = {
  key: 0,
  class: "login-popup"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Enter your folder name"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Enter the user password"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("(This password is used for everyone who you want to give access to. This password has read/view only access.)")
  ]),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Enter the admin password"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("(This password is used for admin only. This password has all the access to all the photos including add and delete.)")
  ])
], -1))
const _hoisted_44 = { class: "popup-content-row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Folder", -1))
const _hoisted_46 = { class: "popup-content-row" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "User Password", -1))
const _hoisted_48 = { class: "popup-content-row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Admin Password", -1))
const _hoisted_50 = { class: "popup-buttons" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "popup-error" }
const _hoisted_54 = { class: "popup-success" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","text-align":"center"} }, [
  /*#__PURE__*/_createTextVNode("Are you sure you want to delete the entire folder?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("By doing this, you'll delete the entire folder with all the photos that you've uploaded."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "THIS ACTION CANNOT BE UNDONE")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: _ctx.selectedTransition }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("img", {
          class: "slideshow-img",
          key: "0",
          onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.evenImageLoaded && _ctx.evenImageLoaded(...args))),
          ref: "evenImage",
          onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.imgMouseDown && _ctx.imgMouseDown(...args))),
          onTouchend: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.imgMouseDown && _ctx.imgMouseDown(...args))),
          onError: _cache[3] || (_cache[3] = ($event: any) => (_ctx.evenImageError = true))
        }, null, 544), [
          [_vShow, _ctx.showEven && (!_ctx.evenImageError || !_ctx.oddImageError)]
        ]),
        _withDirectives(_createElementVNode("img", {
          class: "slideshow-img",
          key: "1",
          onLoad: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.oddImageLoaded && _ctx.oddImageLoaded(...args))),
          ref: "oddImage",
          onMousedown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.imgMouseDown && _ctx.imgMouseDown(...args))),
          onTouchend: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.imgMouseDown && _ctx.imgMouseDown(...args))),
          onError: _cache[7] || (_cache[7] = ($event: any) => (_ctx.oddImageError = true))
        }, null, 544), [
          [_vShow, !_ctx.showEven && (!_ctx.evenImageError || !_ctx.oddImageError)]
        ])
      ]),
      _: 1
    }, 8, ["name"]),
    (_ctx.evenImageError && _ctx.oddImageError)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "no-images-available",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.imgMouseDown && _ctx.imgMouseDown(...args)))
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "control-transition" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("audio", {
            src: _ctx.songSrc,
            ref: "audioControl",
            onLoadeddata: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.audioLoaded && _ctx.audioLoaded(...args))),
            onError: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.audioError && _ctx.audioError(...args))),
            onPlaying: _cache[11] || (_cache[11] = ($event: any) => (_ctx.songPlaying = true)),
            onPlay: _cache[12] || (_cache[12] = ($event: any) => (_ctx.songPlaying = true)),
            onPause: _cache[13] || (_cache[13] = ($event: any) => (_ctx.songPlaying = false)),
            onEnded: _cache[14] || (_cache[14] = ($event: any) => (_ctx.getSong(true))),
            onTimeupdate: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.songTimeUpdate && _ctx.songTimeUpdate(...args)))
          }, null, 40, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.getSong(false))),
              src: _imports_0
            }),
            _createElementVNode("img", {
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.songPlayPauseClicked && _ctx.songPlayPauseClicked(...args))),
              src: require(`@/assets/${_ctx.songPlaying ? 'Pause.png' : 'Play.png'}`)
            }, null, 8, _hoisted_5),
            _createElementVNode("img", {
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.getSong(true))),
              src: _imports_1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "bar-container",
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.songBarClicked && _ctx.songBarClicked(...args)))
            }),
            _createElementVNode("div", {
              class: "bar-fill",
              style: _normalizeStyle({ width: `${_ctx.songFIllWidth}%` })
            }, null, 4)
          ])
        ], 512), [
          [_vShow, _ctx.showControls]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "settings-transition" }, {
      default: _withCtx(() => [
        (_ctx.showControls)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showSettings = !_ctx.showSettings)),
              class: "settings-icon",
              src: _imports_2,
              alt: ""
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slideshow-play-pause" }, {
      default: _withCtx(() => [
        (_ctx.showControls)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "slideshow-play-icon",
              src: require(`@/assets/${_ctx.slideshowPlaying ? 'Pause.png' : 'Play.png'}`),
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.slideshowPlaying = !_ctx.slideshowPlaying))
            }, null, 8, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "settings-popup-transition" }, {
      default: _withCtx(() => [
        (_ctx.showSettings)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "settings-popup-background",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showSettings = false))
              }),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.folderNameInput) = $event)),
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.folderNameInput]
                  ]),
                  (_ctx.accessLevel == 'ADMIN')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        style: {"background":"red","color":"white","cursor":"pointer"},
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showDeleteFolderPopup = true))
                      }, "Delete Folder"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    max: 10,
                    min: 3,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.intervalInput) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.intervalInput]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    id: "randomcb",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.randomImageChecked) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.randomImageChecked]
                  ]),
                  _hoisted_16
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.saveSettingsClicked && _ctx.saveSettingsClicked(...args)))
                  }, "Save"),
                  _createElementVNode("button", {
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showSettings = !_ctx.showSettings))
                  }, "Cancel"),
                  _createElementVNode("button", {
                    onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.addImageClicked && _ctx.addImageClicked(...args)))
                  }, _toDisplayString(_ctx.accessLevel == 'ADMIN' ? 'Add Photos' : 'View Photos'), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.changeFolderClicked && _ctx.changeFolderClicked(...args))),
                    style: {"white-space":"nowrap","background-color":"indianred"}
                  }, "Change folder"),
                  (_ctx.accessLevel == 'ADMIN' && !_ctx.allowRemoteControl)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        style: {"white-space":"nowrap"},
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showRemote = true))
                      }, "Show Remote"))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.accessLevel == 'ADMIN' && _ctx.canShare)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        style: {"max-width":"unset"},
                        placeholder: "Share password",
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.sharePassword) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.sharePassword]
                      ]),
                      _createElementVNode("button", {
                        disabled: _ctx.sharing,
                        style: {"white-space":"nowrap"},
                        onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.shareClicked && _ctx.shareClicked(...args)))
                      }, _toDisplayString(_ctx.sharing ? 'Sharing' : 'Share'), 9, _hoisted_20)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.shareError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.shareError), 1))
                  : _createCommentVNode("", true),
                (_ctx.accessLevel == 'ADMIN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        id: "allowRemote",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.allowRemoteControl) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.allowRemoteControl]
                      ]),
                      _hoisted_23
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.settingsError), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "settings-popup-transition" }, {
      default: _withCtx(() => [
        (_ctx.showRemote)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allRemoteControls, (r, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "remote-item",
                    key: i
                  }, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.remoteClicked(r.key))
                    }, _toDisplayString(r.text), 9, _hoisted_29),
                    _createElementVNode("div", null, _toDisplayString(r.description), 1)
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("input", {
                    type: "range",
                    min: "0",
                    max: "100",
                    value: "100",
                    onInput: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.volumeChangedRemotely && _ctx.volumeChangedRemotely(...args)))
                  }, null, 32)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.showRemote = false)),
                  style: {"background-color":"indianred","color":"white","width":"fit-content","padding":"5px"}
                }, "Close Remote")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "login-popup" }, {
      default: _withCtx(() => [
        (_ctx.showLoginPopup)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.loginFolder) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.loginFolder]
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.loginPassword) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.loginPassword]
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("button", {
                  onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.loginClicked && _ctx.loginClicked(...args))),
                  disabled: _ctx.loggingIn
                }, _toDisplayString(_ctx.loggingIn ? 'Connecting' : 'Connect'), 9, _hoisted_39),
                _createElementVNode("button", {
                  onClick: _cache[40] || (_cache[40] = ($event: any) => {_ctx.showLoginPopup = false; _ctx.showRegisterPopup = true}),
                  disabled: _ctx.loggingIn
                }, "Create Folder", 8, _hoisted_40)
              ]),
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.loginError), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "login-popup" }, {
      default: _withCtx(() => [
        (_ctx.showRegisterPopup)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.registerFolder) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.registerFolder]
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.registerUserPassword) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.registerUserPassword]
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.registerAdminPassword) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.registerAdminPassword]
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("button", {
                  onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.registerClicked && _ctx.registerClicked(...args))),
                  disabled: _ctx.registering
                }, "Create", 8, _hoisted_51),
                _createElementVNode("button", {
                  onClick: _cache[45] || (_cache[45] = ($event: any) => {_ctx.showLoginPopup = true; _ctx.showRegisterPopup = false}),
                  disabled: _ctx.registering
                }, "Connect", 8, _hoisted_52)
              ]),
              _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.registerError), 1),
              _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.registerSuccess), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Popup, {
      showPopup: _ctx.showDeleteFolderPopup,
      onButtonClicked: _ctx.deleteFolderPopupButtonClicked,
      title: "Delete Folder",
      buttons: [
        { buttonText: 'Delete', backgroundColor: 'red', color: 'white' },
        { buttonText: 'Cancel', backgroundColor: 'gray', color: 'white' },
      ]
    }, {
      default: _withCtx(() => [
        _hoisted_55
      ]),
      _: 1
    }, 8, ["showPopup", "onButtonClicked"])
  ]))
}